import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {Moment} from 'moment-timezone';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {ECEconomicsRedistributedPod} from 'smag-commons/dto/eco/community';
import {isDefined} from '../../../../commons/commons';
import {CappedVAIRedistributionPODSettings} from '../ec-economics-redistributed.component';
import {limitDecimals} from '../../../../shared/ec-economics';

export interface CAP {
    threshold: number;
    POD: string;
    year: number;
    month: number;
}

@Component({
    selector: 'app-cap-selector',
    templateUrl: './cap-selector.component.html',
    styleUrls: ['./cap-selector.component.scss']
})
export class CapSelectorComponent implements OnInit, OnDestroy {
    private destroyed = new Subject<void>();

    @Input() date: Moment;
    @Input() pod: ECEconomicsRedistributedPod;
    @Output() capThreshold: EventEmitter<CAP> = new EventEmitter<CAP>();
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();

    year: number;
    form: FormGroup;

    readonly limitDecimals = limitDecimals;

    constructor(private readonly fb: FormBuilder) {
        this.form = this.fb.group(
            {cap: new FormControl(null, [Validators.required])},
            {validators: [validate]});
    }

    ngOnInit() {
        const cappedRedistributionPodSettings: CappedVAIRedistributionPODSettings = this.pod.redistribution;
        if (isDefined(cappedRedistributionPodSettings) && isDefined(cappedRedistributionPodSettings.cap)) {
            this.form.controls.cap.setValue(cappedRedistributionPodSettings.cap * 100);
        }
        this.year = this.date.year();
        this.form.valueChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(value => {
                this.capThreshold.emit({
                    threshold: value.cap,
                    POD: this.pod.pod,
                    year: this.year,
                    month: this.date.month() + 1
                } as CAP);
            });
        this.form.statusChanges
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => this.valid.emit(this.form.valid));
    }

    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }

}

function validate(ctrl: AbstractControl): ValidationErrors | null {
    const errs: ValidationErrors = {};
    const ctrls: { [ctrl: string]: AbstractControl } = (ctrl as FormGroup).controls;
    if ((ctrls.cap.value < 0 || ctrls.cap.value > 100)) {
        errs.out_of_range_values = true;
    }
    return Object.values(errs).every(err => !err) ? null : errs;
}
